module.exports = __webpack_public_path__ + "static/media/facebook.2038ce78.svg";